import { render } from "./AddPartnerView.vue?vue&type=template&id=57591859&scoped=true"
import script from "./AddPartnerView.vue?vue&type=script&lang=js"
export * from "./AddPartnerView.vue?vue&type=script&lang=js"

import "./AddPartnerView.vue?vue&type=style&index=0&id=57591859&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57591859"]])

export default __exports__